import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { MasterMappingHeadersModel } from '../models/masterMappingHeaders.model';
import { EngagementMappingHeadersModel } from '../models/flatfile.model';
import { InfraService } from './infra.service';

@Injectable()
export class MasterMappingHeadersService {
  
  private configCoreUrl: string;
  private pythonUrl :string;

  constructor(private infraService:InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      
      this.configCoreUrl = data.WebEndPoint2 + 'MasterMappingHeader';
    });
    
    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

   
  }

  public getMasterMappingHeaders(): Observable<MasterMappingHeadersModel[]> {
    return this.http.get<MasterMappingHeadersModel[]>(`${this.configCoreUrl}` + '/' + 'getMasterMappingHeaders' );
    
  }



  private handleError(error: Response) {
    return throwError(()=> error);
  }


}
